import script from "./DepthTasksContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./DepthTasksContainer.vue?vue&type=script&setup=true&lang=js"

import "./DepthTasksContainer.vue?vue&type=style&index=0&id=59bfccd3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59bfccd3"]])

export default __exports__